"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableData = exports.TableRow = exports.TableWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../themes/colors");
exports.TableWrapper = styled_components_1.default.table `
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;

  & > :last-child {
    & > td {
      border-bottom: none;
    }
  }

  // don't change bg on header row on hover
  & > tbody > tr:hover {
    background-color: ${colors_1.colors.verseCardColor};
  }
`;
exports.TableRow = styled_components_1.default.tr `
  ${({ theme, nowrap = true }) => (0, styled_components_1.css) `
    & > th {
      padding: ${theme.spacing.unit}px 0;
      border-bottom: ${theme.border.style} ${theme.palette.border.secondary};
      border-top: ${theme.border.style} ${theme.palette.border.secondary};
      white-space: ${nowrap ? 'nowrap' : 'normal'};
    }

    & > td {
      padding: 13px 0px;
      white-space: ${nowrap ? 'nowrap' : 'normal'};
    }
  `}
`;
exports.TableData = styled_components_1.default.td `
  ${({ theme, textAlign }) => (0, styled_components_1.css) `
    padding: ${theme.spacing.unit}px;
    text-align: ${textAlign};
  `}
`;
//# sourceMappingURL=styled.js.map